<template>
  <fieldset :class="{ 'app-embedded-fieldset': embedded }"><!-- using fieldset as verification code was expected in future release -->
    <legend>
      <span :class=" isRequired ?  'app-required-indicator __after' : '' ">{{ titleEmail }}</span>
    </legend>
    <div class="app-contact-inputs">
      <ValidationObserver ref="emailObserver">
        <ValidationProvider name="email address" v-slot="{ errors }" rules="email|max:80" mode="lazy">
          <div class="app-input-group app-contact-info" :class="{ 'app-invalid-group': errors.length > 0 || invalidEmailChars }"
               ref="emailGroup">
            <label for="userEmail" class="sr-only">Enter your email address</label>
            <input class="app-user-email" :id="userEmail" ref="userEmail" type="email" v-model="myEmail" @blur="checkEmail" :readonly="editable"
             :disabled="editable">
            <p v-if="invalidEmailChars" ref="invalidChar">Email address contains invalid characters.</p>
            <p v-else ref="invalidEmail">{{ errors[0] }}</p>
          </div>
        </ValidationProvider>
      </ValidationObserver>
    </div>
  </fieldset>
</template>

<script>
import { mapState } from 'vuex'
import { setInteractionMode , ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { email, max } from 'vee-validate/dist/rules'

extend('email', {
  ...email,
  message: (field, params) => {
    return `Please enter a valid ${params._field_}.`;
  }
});
extend('max', {
  ...max,
  message: (field, params) => {
    return `${params._field_} is limited to ${params.length} characters.`;
  }
});

export default {
  name: 'ContactEmail',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    embedded: {             // embedded fieldset (in Step 3)?
      type: Boolean,
      required: false,
      default: false,
    },
    isModal: {              // technically not needed but for code consistency only
      type: Boolean,        // see ContactPhone
      required: false,
      default: false,
    },
    verify: {
      type: Boolean,
      required: false,
      default: false,
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    titleEmail: {
      type: String,
      required: false,
      default: 'Email',
    },
    userEmail: {
      type: String,
      required: false,
      default: 'userEmail',
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  computed: {
    ...mapState([
      // 'reservationSlotId',
      // 'resDetails',
    ]),
    invalidEmailChars() {
      const pattern = /^[a-zA-Z0-9@._-]*$/;
      return !pattern.test(this.myEmail);
    },
  },
  data() {
    return {
      myEmail: '',
      invalidSelector: 'app-invalid-group',
    };
  },
  watch: {
    myEmail() {
      // applicable to both Step 3 (non-modal) and Confirmation/Reminder modal in Step 5
      this.checkEmail();
    },
    /**
     * For Step 3 (non-modal) only. Step 5 modal depends on myEmail watcher.
     * Modal props do not behave like regular components (Step 3) where a child does not always detect
     * its parent's bound variable when it's changed.
     */
    verify() {
      // parent to signal user's intention to move on
      if (this.verify) {
        this.checkEmail();
      }
    },
  },
  created() {
    setInteractionMode('aggressive');
  },
  mounted() {
    // pre-fill if info is available
    if (this.$store.state.guestLogin.finalizationCart && this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart) {
      const info = this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart;
      if (info && info.email && info.email.length > 0) {
        this.myEmail = info.email;
      }
    }
  },
  methods: {
    /**
     * Work for both Step 3 and modal in Step 5. Need BOTH watch and blur events to cover all bases.
     * Implementation differs from ContactPhone due to lack of ValidationProvider error object access
     */
    checkEmail() {
      const badEmail = this.hasInvalidEmailMessage();
      const hasError = badEmail || (this.myEmail.length > 0 && this.invalidEmailChars);
      this.$refs.emailObserver.validate();

      if (hasError) {
        this.$emit('doResetVerify');
      }

      // isValid is only used by ModalContact (not UserContact)
      this.$emit('doEmail', { email: this.myEmail, isValid: !hasError });
    },
    hasInvalidEmailMessage() {
      const elem = this.$refs.invalidEmail;
      return (elem && elem.innerHTML.length > 0);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/contact";
</style>
